import { UserXeroPayment } from "./Users";

export enum EPackageStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "DEACTIVE",
}

export enum EDURATION_TYPE {
  DAY = "DAY",
  MONTH = "MONTH",
}

export interface IPackage {
  id: string;
  name: string;
  description?: string;
  price: number;
  numberOfCredit?: number;
  duration?: number; // in days
  discount?: number; // percentage
  isPopular: boolean;
  status: EPackageStatus;
  createdAt: string;
  updatedAt: string;
  code?: string;
  isHidden?: boolean;
  expiredAt?: string;
  durationType?: EDURATION_TYPE;
  xeroPayment: UserXeroPayment;
}

export interface ICreatePackageDTO {
  name: string;
  description?: string;
  code?: string;
  price: number;
  numberOfCredit?: number;
  duration?: number;
  discount?: number;
  status: EPackageStatus;
  isPopular: boolean;
  isHidden: boolean;
  durationType?: EDURATION_TYPE;
}

export interface IUpdatePackageDTO {
  name?: string;
  description?: string;
  code?: string;
  price?: number;
  numberOfCredit?: number;
  duration?: number;
  discount?: number;
  status?: EPackageStatus;
  isPopular: boolean;
  isHidden: boolean;
  durationType?: EDURATION_TYPE;
}

export interface IUserPackageResponse {
  package: IPackage;
  createdAt: string;
  updatedAt: string;
  enabled: true;
  expiredAt: string;
  id: string;
  isExpired: false;
}

export interface ICreateUserPackageDTO {
  packageId: string;
  userId: string;
}

export interface IUpdateUserPackageDTO {
  packageId: string;
  expiredAt: string | null;
  enabled: boolean;
}
